import React, { useEffect, useState } from "react";
import Layout from "../../page/layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";

const PetaniAddLahan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  // States for each field
  const [kategorilahan, setKategoriLahan] = useState("");
  const [lokasilahan, setLokasiLahan] = useState("");
  const [luaslahan, setLuasLahan] = useState("");
  const [periodeTanamMulai, setPeriodeTanamMulai] = useState("");
  const [periodeTanamSelesai, setPeriodeTanamSelesai] = useState("");
  const [namePerusahaan, setNamePerusahaan] = useState("");
  const [namaPerusahaanOptions, setNamaPerusahaanOptions] = useState([]);
  const [msg, setMsg] = useState("");

  const saveLahan = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `https://c-greenproject.org:8000/petanidasar`,
        {
          kategorilahan,
          namePerusahaan: kategorilahan === "Plasma" ? namePerusahaan : null,
          lokasilahan,
          luaslahan,
          periodeTanamMulai,
          periodeTanamSelesai,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate("/datalahan");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  useEffect(() => {
    const fetchNamaPerusahaanOptions = async () => {
      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/perusahaan/options`
        );
        setNamaPerusahaanOptions(response.data);
      } catch (error) {
        console.error("Error fetching nama perusahaan options:", error);
      }
    };

    fetchNamaPerusahaanOptions();
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "petani") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  return (
    <Layout>
      <nav aria-label="breadcrumb pb-0">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/datalahan">Data Lahan</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Tambah Data Lahan
          </li>
        </ol>
      </nav>

      <h2 className="title">
        <strong>Tambah Data Lahan</strong>
      </h2>
      <div className="card is-shadowless">
        <div className="card-content ps-4 mb-3">
          <div className="content">
            <form onSubmit={saveLahan}>
              <p className="has-text-centered">{msg}</p>

              <div className="add-lahan">
                <div className="column lahan">
                  <div className="field mb-2">
                    <label className="label">Kategori Lahan</label>
                    <div className="control">
                      <div className="select">
                        <select
                          value={kategorilahan}
                          onChange={(e) => setKategoriLahan(e.target.value)}
                        >
                          <option value="">Pilih Kategori Lahan</option>
                          <option value="Inti">Lahan Inti</option>
                          <option value="Plasma">Lahan Plasma</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {kategorilahan === "Plasma" && (
                    <div className="field mb-2">
                      <label className="label">Nama Perusahaan</label>
                      <div className="control">
                        <div className="select">
                          <select
                            value={namePerusahaan}
                            onChange={(e) => setNamePerusahaan(e.target.value)}
                          >
                            <option value="">Pilih Nama Perusahaan</option>
                            {namaPerusahaanOptions.map((option) => (
                              <option key={option.id} value={option.name}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="field mb-2">
                    <label className="label">Lokasi Lahan</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        value={lokasilahan}
                        onChange={(e) => setLokasiLahan(e.target.value)}
                        placeholder="Lokasi Lahan"
                      />
                    </div>
                  </div>

                  <div className="field mb-2">
                    <label className="label">Luas Lahan (ha) </label>
                    <div className="control">
                      <input
                        type="number"
                        className="input"
                        value={luaslahan}
                        onChange={(e) => setLuasLahan(e.target.value)}
                        placeholder="Luas Lahan"
                      />
                    </div>
                  </div>

                  <div className="field mb-2">
                    <label className="label">Periode Tanam Mulai</label>
                    <div className="control">
                      <input
                        type="date"
                        className="input"
                        value={periodeTanamMulai}
                        onChange={(e) => setPeriodeTanamMulai(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="field mb-2">
                    <label className="label">Periode Tanam Selesai</label>
                    <div className="control">
                      <input
                        type="date"
                        className="input"
                        value={periodeTanamSelesai}
                        onChange={(e) => setPeriodeTanamSelesai(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="field mt-2">
                <div className="control">
                  <button
                    type="submit"
                    className="btn btn-success button-detail"
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PetaniAddLahan;
